var s = function() {
  return s = Object.assign || function(n) {
    for (var t, r = 1, e = arguments.length; r < e; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (n[a] = t[a]);
    }
    return n;
  }, s.apply(this, arguments);
};
export {
  s as __assign
};
